import { useDebugValue as r } from "react";
import t from "./useState.js";

var useForceUpdate = function useForceUpdate() {
  var n = t(-1),
      e = n[0],
      o = n[1];
  return r("Tick " + e), function () {
    return o(function (r) {
      return r + 1;
    });
  };
};

export default useForceUpdate;